import * as React from "react";
import { styled } from "@mui/system";
import MUICircularProgress from "@mui/material/CircularProgress";
import { CircularProgressProps as CircularProgressPropsMUI } from "@mui/material/CircularProgress";
export interface CircularProgressProps extends CircularProgressPropsMUI {}

export const CircularProgress: (props: CircularProgressProps) => JSX.Element =
  styled(
    React.forwardRef<HTMLSpanElement, CircularProgressProps>((props, ref) => (
      <MUICircularProgress ref={ref} {...props} />
    )),
    {
      name: "CircularProgress",
      slot: "Root",
      overridesResolver: (props, styles) => []
    }
  )(({ theme }) => ({
    "&.MuiCircularProgress-root.MuiCircularProgress-indeterminate.MuiCircularProgress-colorPrimary":
      {
        color: theme.palette.primary.interactiveDefault
      },
    "&.MuiCircularProgress-root.MuiCircularProgress-determinate.MuiCircularProgress-colorPrimary":
      {
        color: theme.palette.primary.interactiveDefault
      }
  }));
